import React, { useEffect, useRef } from "react";

export default function CartPanel({ lines, onInc, onDec, onRemove, totals, highlightId, activeId }) {
  // refs par ligne pour focus/scroll
  const rowRefs = useRef({});
  const plusBtnRefs = useRef({});

  useEffect(() => {
    if (!activeId) return;
    const el = rowRefs.current[activeId];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    const plus = plusBtnRefs.current[activeId];
    if (plus && plus.focus) {
      plus.focus({ preventScroll: true });
    }
  }, [activeId]);

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">Panier</h5>
        {lines.length === 0 ? (
          <p className="text-muted">Aucun article</p>
        ) : (
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Article</th>
                <th>Qté</th>
                <th>Prix</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {lines.map((l) => (
                <tr
                  key={l.itemId}
                  ref={(el) => (rowRefs.current[l.itemId] = el)}
                  className={[
                    highlightId === l.itemId ? "table-success fade-highlight" : "",
                    activeId === l.itemId ? "row-active" : "",
                  ].join(" ").trim()}
                >
                  <td>{l.name}</td>
                  <td>
                    <div className="d-flex align-items-center gap-1">
                      <button className="btn btn-sm btn-light" onClick={() => onDec(l.itemId)}>-</button>
                      <span className="px-2">{l.qty}</span>
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => onInc(l.itemId)}
                        ref={(el) => (plusBtnRefs.current[l.itemId] = el)}
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td>{l.price.toLocaleString()} FCFA</td>
                  <td>{(l.price * l.qty).toLocaleString()} FCFA</td>
                  <td>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => onRemove(l.itemId)}>
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr><th colSpan={3}>Total</th><th>{totals.grandTotal.toLocaleString()} FCFA</th><th></th></tr>
            </tfoot>
          </table>
        )}
      </div>
    </div>
  );
}
